import Switch from "react-ios-switch";
import React from "react";

const SwitchButton = (props) => {
    return <Switch
        className={`sl-ios-switch ${props.checked ? 'sl-ios-switch-checked' : ""}`}
        handleColor="white"
        offColor="#F2F4F7"
        onColor="#1570EF"
        {...props}
    />
}

export default SwitchButton;